
<template>
  <div>
    <div class="item_box box10" id="box10">
      <div class="item_box_wp">
        <div class="voice_2">
          <ul>
            <li class="li1" style="width:50%">
              <div class="fold" style="display:none;">
                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/gaoxin.png`" /></span>
                <span class="txt">高新技术</span>
              </div>
              <div class="unfold" style="display:block">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/gaoxin.png`" />&nbsp;&nbsp;高新技术</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">销售收入、技术服务费、软著升级费、认证服务费、增值税（即征即退）、结转研发费用...</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 懂得高新技术企业什么收入可以即征即退</p>
                  <p style="font-size: 15px;">2. 熟知高新企业如何办理即征即退</p>
                  <p style="font-size: 15px;">3. 掌握研发费用如何加计扣除</p>
                  <p style="font-size: 15px;">4. 懂得高新技术企业市高. 国高的申请与复核</p>
                  <p style="font-size: 15px;">5. 学会高新企业的季报/年报填写</p>
                  <p style="font-size: 15px;">6. 了解高新技术企业的其他补贴</p>
                  <!-- <br> -->
                  <button class="next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>
            <li class="li2" style="width:50%">

              <div class="fold">

                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/wm.png`" /></span>

                <span class="txt">外贸企业</span>

              </div>

              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">

                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/wm.png`" />&nbsp;&nbsp;外贸企业</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">收汇、结汇、对外销售、代理运费支出、调整外币户汇兑损益、成本结转、计提退税款...</p>
                  <!-- <br /> -->

                  <p style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解外贸企业的概述</p>
                  <p style="font-size: 15px;">2. 掌握外贸企业如何办理出口退税</p>
                  <p style="font-size: 15px;">3. 学习外贸企业账务处理的前期准备</p>
                  <p style="font-size: 15px;">4. 熟知贸易型外贸企业常见的账务处理方式</p>
                  <p style="font-size: 15px;">5. 懂得外贸企业怎么退税处理</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>
            <li class="li3" style="width:50%">
              <div class="fold">

                <span class="images"> <img style="width: 50px;height:50px;"
                                           :src="`${assetsUrl}imgs/sxgc/jz.png`" /></span>

                <span class="txt">建筑施工</span>

              </div>
              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}}imgs/sxgc/jz.png`" />&nbsp;&nbsp;建筑施工</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">
                    工程收入、工程结算、合同成本、合同毛利、工程施工、临时设施、辅助生产、工程物资、机械作业、...</p>
                  <!-- <br /> -->

                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解建筑施工企业的业态</p>
                  <p style="font-size: 15px;">2. 熟知建筑施工企业账务处理的前期准备</p>
                  <p style="font-size: 15px;">3. 掌握工程施工的账务处理</p>
                  <p style="font-size: 15px;">4. 学习建筑施工的涉税处理</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>
            <li class="li4" style="width:50%">
              <div class="fold">
                <span class="images"> <img style="width: 50px;height:50px;"
                                           :src="`${assetsUrl}imgs/sxgc/jd.png`" /></span>
                <span class="txt">酒店餐饮</span>
              </div>
              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/jd.png`" />&nbsp;&nbsp;酒店餐饮</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">
                    购入食材、商品进销差价、各部门交来日报表账务处理、收到挂账餐费、挂账处理、退房结余、支付厨房客房各项支出、月末盘点库存、结转材料成本...</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 掌握酒店餐饮行业特性，做好库存和采购</p>
                  <p style="font-size: 15px;">2. 学会酒店餐饮行业如何做好账务分类</p>
                  <p style="font-size: 15px;">3. 懂得酒店餐饮行业的期末库存盘实</p>
                  <p style="font-size: 15px;">4. 熟知酒店餐饮行业怎么节税</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>
            <li class="li5" style="width:50%">
              <div class="fold">
                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/fdc.png`" /></span>
                <span class="txt">房产置业</span>
              </div>
              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/fdc.png`" />&nbsp;&nbsp;房产置业</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">拍卖押金、开发成本、取得土地使用权所支付金额、土地价款、契税、耕地占用税、
                    土地征用及拆迁费、市政配套费用、前期工程费、规划管理费、可行性研究费、勘察测绘费...</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解房地产企业的业务范围. 税目及税率</p>
                  <p style="font-size: 15px;">2. 懂得房地产企业获取土地的方式及相关账税处理</p>
                  <p style="font-size: 15px;">3. 掌握房地产企业开发成本的核算</p>
                  <p style="font-size: 15px;">4. 熟知房地产企业销售阶段的账税处理</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>
            <li class="li6" id="li6" style="width:50%">
              <div class="fold">
                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/wl.png`" /></span>
                <span class="txt">物流运输</span>
              </div>
              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/wl.png`" />&nbsp;&nbsp;物流运输</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">
                    租用运输设备、公路联运预收款、运输预收款、仓储场地租赁、货物投保、仓储成本、装卸搬运收入、运输收入、联运费用、车船税、...
                  </p>
                  <!-- <br /> -->

                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解物流企业的业务概述</p>
                  <p style="font-size: 15px;">2. 掌握物流企业的会计核算</p>
                  <p style="font-size: 15px;">3. 懂得物流企业的行业特性</p>
                  <p style="font-size: 15px;">4. 学会物流企业在实务中的税务处理</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>

              </div>

            </li>

            <li class="li7">

              <div class="fold">
                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/shfw.png`" /></span>
                <span class="txt">生活服务</span>
              </div>

              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;" class="p-magin-1"
                           :src="`${assetsUrl}imgs/sxgc/shfw.png`" />&nbsp;&nbsp;生活服务</h1>
                  <!-- <br> -->
                  <h2>真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">
                    收到旅游款项、散客押金、带团备用金、地接社预付款、行程结束返回、旅游团成本确认、伤者医疗费支出、旅游团加项差价、代订机票、...
                  </p>
                  <!-- <br /> -->

                  <p style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解旅游行业的特点和业务种类</p>
                  <p style="font-size: 15px;">2. 掌握旅游企业会计核算及其特点</p>
                  <p style="font-size: 15px;">3. 学会旅游企业在实务中的税务处理</p>
                  <p style="font-size: 15px;">4. 学会物流企业在实务中的税务处理</p>
                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>
              </div>
            </li>

            <li class="li8">

              <div class="fold">

                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/nlmy.png`" /></span>

                <span class="txt">农林牧渔</span>

              </div>

              <div class="unfold">

                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/nlmy.png`" />&nbsp;&nbsp;农林牧渔</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <br>
                  <p style="font-size: 15px;">出售成鱼收入、鱼塘承包费、人工费、渔需物资、养殖原料、鱼苗成本、农家乐活动、饲料费、结转鱼苗相关费用、结转饲料费...</p>
                  <!-- <br /> -->

                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解农林牧渔企业的概述</p>
                  <p style="font-size: 15px;">2. 了解农业企业的会计概述</p>
                  <p style="font-size: 15px;">3. 掌握农业企业的行业特有科目的会计处理（生物资产）</p>
                  <p style="font-size: 15px;">4. 学会农业企业在实务中的税务处理</p>

                  <!-- <br /><br> -->
                  <button class="p-magin-1" @click="openWindow()">进入实训</button>
                </div>

              </div>

            </li>
            <li class="li9">

              <div class="fold">

                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}imgs/sxgc/sydw.png`" /></span>

                <span class="txt">事业单位</span>

              </div>

              <div class="unfold">
                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}imgs/sxgc/sydw.png`" />&nbsp;&nbsp;事业单位</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <br>
                  <p style="font-size: 15px;">
                    医疗收入、预收医疗款、应收在院病人医疗款、医疗业务成本、应付社会保障费、结算差额、专用基金、财政补助收入、科教项目收入、应收医疗款...</p>
                  <!-- <br /> -->

                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解行政事业单位的概述</p>
                  <p style="font-size: 15px;">2. 了解行政事业单位的会计概述</p>
                  <p style="font-size: 15px;">3. 掌握会计核算内容及方法的特殊性（平行记账）</p>

                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>

              </div>

            </li>
            <li class="li10">

              <div class="fold">

                <span class="images"> <img style="width: 50px;height: 50px;"
                                           :src="`${assetsUrl}}imgs/sxgc/jrtz.png`" /></span>

                <span class="txt">金融投资</span>

              </div>

              <div class="unfold">

                <div style="width: 80%; margin-top: 20px;margin-left: 10%; height: auto;">
                  <h1><img style="width: 40px;height: 40px;"
                           :src="`${assetsUrl}}imgs/sxgc/jrtz.png`" />&nbsp;&nbsp;金融投资</h1>
                  <!-- <br> -->
                  <h2 class="p-magin-1">真账真税 顶岗实习</h2>
                  <!-- <br /> -->
                  <p class="p-magin-1" style=" font-size: 18px;font-weight: bold;">核心业务：</p>
                  <!-- <br> -->
                  <p class="p-magin-1" style="font-size: 15px;">增值税、附加税、放贷、贷款结息、季度结息、贷款利息、还款结息、所得税...</p>
                  <!-- <br /> -->

                  <p class="p-magin-1" style="font-size: 18px;font-weight: bold;">$&nbsp;课程收益：</p>
                  <!-- <br /> -->
                  <p class="p-magin-1" style="font-size: 15px;">1. 了解金融投资企业概述，银行业概述</p>
                  <p style="font-size: 15px;">2. 学会金融投资企业存款业务的核算</p>
                  <p style="font-size: 15px;">3. 掌握金融投资企业贷款与贴现业务的核算</p>
                  <p style="font-size: 15px;">4. 了解金融投资企业的中间业务</p>
                  <p style="font-size: 15px;">5. 学会营改增后金融投资企业的涉税问题</p>

                  <!-- <br /> -->
                  <button class="p-magin-1 next" @click="openWindow()">进入实训</button>
                </div>

              </div>

            </li>
            <div class="clear"></div>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
// import { authServerCostAcc } from '@/api/myAddition'
export default {
  name: 'SxgcAcc',
  components: {

  },
  data() {
    return {
    assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
    planclassesId: '',
    classesId: '',
    para: {
      classesId: 'cbfe6de5a8bd19f2a7df1b88985b5155',
      planclassesId: '1375ff50401df0e76f05dac1ad844d6a'
    },
    domain: '1',
    domainData: { courseId: 3 },
    info: '1',
    nextUrl: '1',
    errorMess: '1',
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
<style scoped lang="less">
@charset "utf-8";
/* CSS Document */

body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,button,textarea,select,p,blockquote,th,td,hr { margin: 0px; padding: 0px;}
body { font-size: 12px; line-height: 1.5; font-family: 微软雅黑; background: #fff;}
h1,h2,h3,h4,h5,h6 { font-family: arial,"hiragino sans gb","microsoft yahei","Simsun",sans-serif; font-size: 100%; font-weight:normal;}
input,textarea,select,button { font-size: 12px;font-weight: normal; vertical-align:middle;}
input[type='button'],input[type='submit'],select,button { cursor: pointer;}
table { border-spacing: 0;}
address,caption,cite,code,dfn,em,th,var { font-style: normal; font-weight: normal;}
li { list-style: none;}
caption,th { text-align: left;}
q:before,q:after { content: "";}
abbr,acronym { border: 0 none; font-variant: normal;}
sup { vertical-align: text-top;}
sub { vertical-align: text-bottom;}
fieldset,img,a img,iframe { border-style: none; border-width:0;}
img { vertical-align: middle; vertical-align: middle; outline: none;}
textarea { overflow-y:auto; }
legend { color: #000;}
a { text-decoration: none; outline: none; cursor: pointer; color: #298ff8;}
a:link,a:visited { text-decoration: none;}
hr {height: 0;}

/*---------------首页---------------*/
/*首页banner*/
.ft_banner { width: 100%; /*background: url("img/banner12.png") center center no-repeat;*/ height: 660px;}
.ft_banner_wp { width: 1180px; margin: 0 auto; position: relative;}

/*轮播图*/
.banner_box{width:100%; height:550px; overflow:hidden;}
.banner_box .banner{width:100%; height:550px; overflow:hidden; position:relative;}
.banner_box .banner_list{width:100%; height:550px; position:relative;}
.banner_list li{width:100%; height:550px; position:absolute; left:0; top:0; opacity:0; filter:alpha(opacity=0);}
.banner_list .bm1{/*background:url(img/banner1.png) 50% 0 #319ACC no-repeat;*/}
.banner_list .bm2{/*background:url(img/banner2.png) 50% 0 #5390D5 no-repeat;*/}
/*.banner_list .bm3{background:url(img/banner3.png) 50% 0 no-repeat;}
.banner_list .bm4{background:url(img/banner4.png) 50% 0 no-repeat;}
.banner_list .bm5{background:url(img/banner5.png) 50% 0 no-repeat;}*/
.slide_btns { position: absolute; width: 1180px; top: 225px; left: 50%; margin-left: -590px; z-index:11;}
.banner_box .prev_btn, .banner_box .next_btn{display:block; width:31px; height:90px; position: absolute; opacity:0.5; filter:alpha(opacity=0);}
.banner_box .prev_btn{left:0px; /*background:url(img/slide_icon.png) 0 0px no-repeat;*/}
.banner_box .next_btn{right:0px;/* background:url(img/slide_icon.png) -39px 0px no-repeat;*/}
.next{color:#000;    margin-top: 15px;}
.banner_box .circle_btns{/*width:100%;*/width:140px; height:20px; position:absolute; bottom:18px; left:50%; text-align:center; z-index:11; margin-left:-70px;}
.banner_box .circle_btns a{display:inline-block; width:20px; height:20px; /*background:url(img/slide_icon.png) -50px -100px no-repeat;*/ margin-right:10px; }
.banner_box .circle_btns .a1{margin-right:0;}
.banner_box .circle_btns .cur{background-position: 0px -100px;}
.banner_list .bm_txt { width: 1180px; margin: 102px auto 0px auto; color: #fefefe; position: relative;}
.banner_list .bm_txt h1 { font-size: 60px; position: absolute; right: 55px; top: 0px;}
.banner_list .bm_txt h2 { font-size: 48px; position: absolute; right: 55px; top: 90px;}
.banner_list .bm_txt p { font-size: 18px; position: absolute; right: 55px;}
.banner_list .bm_txt p.p1 { top: 189px;}
.banner_list .bm_txt p.p2 { top: 233px;}

.banner_list .bm2_txt p.p3 { top: 278px;}

/*首页*/
.item_box { width: 100%; padding: 0px 0px 82px 0px; overflow: hidden;}
.item_box_wp { width: 100%; margin:0 auto;}
.item_box_wp .title {/* background: url("img/cloud.png") center center no-repeat;*/ width: 1180px; min-height: 87px; margin: 30px auto 55px auto; text-align: center;}
.item_box_wp .title h1 { font-size: 36px; color: #3f616c;}
.item_box_wp .title h2 { font-size: 18px; color: #aaa;}
.item_box_wp h3 { color: #67b83d; font-size: 36px; margin: 74px 0px 50px 0px;}
.item_box_wp h4 { color: #3f616c; font-size: 36px; margin: 65px 0px 25px 0px; text-align: center;}

.box1 { border-bottom: 1px #cccccc solid; }
.box1 ul li { float: left; display: inline; margin-right: 106px; width: 205px; text-align: center; overflow: hidden;}
.box1 ul li.last { margin-right: 0px;}
.box1 ul li dt { background: #fafafa; border-radius: 90px; width: 180px; height: 180px; text-align: center; cursor: pointer; margin-bottom: 20px; margin-left: 18px; font-size: 14px; position: relative;}
.box1 ul li dt a { display: inline-block; color: #333; width: 180px; height: 180px; top: 0px; left: 0px; position: absolute; border-radius: 90px; overflow: hidden; }
.box1 ul li dt i { display: inline-block; text-align: center; vertical-align: middle; /*background: url("img/icon.png") 0 0 no-repeat;*/ position: relative;}
.box1 ul li.li1 dt i { background-position: 0 0; width: 64px; height: 85px; margin: 40px 58px 15px 58px;}
.box1 ul li.li2 dt i { background-position: 0 -101px; width: 94px; height: 94px; margin: 33px 43px 13px 43px; }
.box1 ul li.li3 dt i { background-position: 0 -203px; width: 54px; height: 98px; margin: 27px 63px 13px 63px; }
.box1 ul li.li4 dt i { background-position: 0 -325px; width: 76px; height: 64px; margin: 51px 52px 23px 52px; }
.box1 ul li dt a.hover { top: 0px; left: 0px;}
.box1 ul li.li1 dt a.hover i { background-position: -76px 0; top: -125px;}
.box1 ul li.li2 dt a.hover i { background-position: -108px  -101px; top: -125px;}
.box1 ul li.li3 dt a.hover i { background-position: -67px -203px; top: -125px;}
.box1 ul li.li4 dt a.hover i { background-position: -83px -325px; top: -125px;}
.box1 ul li dt a .txt { position: relative;}
.box1 ul li dt a.hover .txt { right: -100px;}
.box1 ul li dt a.hover .txt { color: #fff;}
.box1 ul li dd { color: #666; font-size: 12px; margin-bottom: 20px; line-height: 22px;}
.box1 ul li dd.tit { font-size: 18px; color: #78b500; font-weight: normal; margin-bottom: 5px; display: inline-block;}
.box1 ul li dd a { display: inline-block; color: #78b500; width: 92px; height: 28px; line-height: 28px; text-align: center; border-radius: 5px; border:1px #78b500 solid;}
.box1 ul li:hover dd a { background: #78b500; color: #fff; }

/*短信、语音、视频等动画*/
.box1 ul li dt {
	transition: background 0.5s;
	-moz-transition: background 0.5s; /* Firefox 4 */
	-webkit-transition: background 0.5s; /* Safari and Chrome */
	-o-transition: background 0.5s; /* Opera */
}
.box1 ul li:hover dt {
	background: #84d23f;
}

.box2 { background: #f9f9f9; padding: 75px 0px 0px 0px; border-bottom: 1px #cccccc solid; }
.index_2 { width: 1180px; margin: 0 auto; position: relative; }
.index_2 span.txt { font-size: 18px; color: #333; background: #fff; display: inline-block; width: 80px; height: 80px; line-height: 80px; border-radius: 40px; box-shadow: 2px 4px 10px #ccc; text-align: center; position: absolute; cursor: pointer;}
.index_2 span.txt1 { left: 69px; top: 202px;}
.index_2 span.txt2 { left: 334px; top: 0px;}
.index_2 span.txt3 { left: 766px; top: 0px;}
.index_2 span.txt4 { left: 1025px; top: 202px;}
.index_2 .txt_desc span { position: absolute;}
.index_2 .txt_desc span em { font-style: normal; position: relative; font-size: 14px; color: #333; display: inline-block; width: 277px; height: 211px;
    // background: url("#{$assetsUrl}/imgs/sxgc/desc_bg.png") 0 0 no-repeat;
    line-height: 35px;
    padding: 32px 44px 0px 44px;}
.index_2 .txt_desc span.span1 img { position: relative; left: -350px; top: -82px;}
.index_2 .txt_desc span.span1 {
    // background: url("../../../../../../assets/imgs/sxgc/img57.png") 0 0  no-repeat;
    top: 108px; left: 284px; width: 650px; height: 306px;}
.index_2 .txt_desc span.span2 { /* background: url("img/img58.png") 0 0  no-repeat;*/ top: 120px; left: 248px; width: 650px; height: 311px;}
.index_2 .txt_desc span.span3 { /*background: url("img/img59.png") 0 0  no-repeat; */top: 160px; left: 248px; width: 650px; height: 202px;}
.index_2 .txt_desc span.span4 { /*background: url("img/img60.png") 0 0  no-repeat; */top: 120px; left: 284px; width: 650px; height: 267px;}
.index_2 .txt_desc span.span1 em { top: 30px; right: -307px;}
.index_2 .txt_desc span.span2 em { top: 18px; right: -343px;}
.index_2 .txt_desc span.span3 em { top: -23px; right: -343px;}
.index_2 .txt_desc span.span4 em { top: 17px; right: -307px;}

/*简单、可靠、专注、全球动画*/
.index_2 span.txt {
transition:transform 1s ease-out;;
-moz-transition:-moz-transform 1s ease-out;; /* Firefox 4 */
-webkit-transition:-webkit-transform 1s ease-out;; /* Safari and Chrome */
-o-transition:-o-transform 1s ease-out;; /* Opera */
}
.index_2 span.txt:hover,.index_2 span.txt.current {
-webkit-transform: scale(1.2);
-moz-transform: scale(1.2);
-o-transform: scale(1.2);
-ms-transform: scale(1.2);
transform: scale(1.2);
}

.box3 { padding: 0px; width: 100%; position: relative; height: 510px;}
.bg_attach1 { width: 100%; /*background: url("img/bg1.png") 0 center fixed no-repeat;*/ position: absolute; top: 0px; left: 0px; height: 1124px; }
.bg_attach2 { width: 100%; background: #3390c1; opacity: 0.6; position: absolute; top: 0px; left: 0px; height: 510px; }
.index_3 { position: relative; z-index: 11; margin: 75px auto 0px auto; width: 1035px;}
.index_3 p span { position: absolute; font-size: 30px; color: #fff; left: 658px;}
.index_3 p .span1 { top: 54px;}
.index_3 p .span2 { top: 157px;}
.index_3 p .span3 { top: 263px;}
.index_3 p .span1 em { display: inline-block; width: 90px;}
.index_3 p .span2 em { display: inline-block; width: 82px;}
.index_3 p .span3 em { display: inline-block; width: 98px;}

.index_4 { width: 995px; margin: 0 auto;}
.box4 .item_box_wp { text-align: center;}
.box4 ul { float: left; display: inline; width: 1000px; border: 1px #eee solid; background: #fff; }
.box4 ul li { float: left; display: inline; width: 248px; border-right: 1px #eee solid; border-bottom: 1px #eee solid; height: 78px; line-height: 78px; cursor: pointer;}
.box4 ul li.last { margin-right: -1px;}
.box4 ul li.bottom { margin-bottom: -1px;}

/*短信*/
.ft_banner1 { width: 100%; height: 430px; /*background: url("img/banner6.png") center center;*/}
.message_1 { margin-top: 70px;}
.message_1 ul { margin-bottom: 68px; overflow: hidden;}
.message_1 ul li { float: left; display: inline; margin: 0px 140px; width: 310px; text-align: center;}
.message_1 dl { width: 100%; text-align: center;}
.message_1 dt { margin-bottom: 15px;}
.message_1 dd { line-height: 25px; font-size: 14px; color: #666;}
.message_1 dd.tit { font-size: 24px; color: #333; margin-bottom: 15px;}
.doc_link { text-align: center;}
.doc_link a { border:1px #aaa solid; border-radius: 4px; padding: 10px 14px; font-size: 14px; color: #666; background: #fff;}

.box6 { /*background: url("img/bg2.png") center center repeat-y;*/ height: 600px; padding: 0px;}
.message_2 { margin-bottom: 42px;}
.message_2 ul li { float: left; display: inline; margin-left: 20px;}
.message_2 ul li.li1 { width: 560px; margin-bottom: 30px;}
.message_2 ul li.li2 { width: 580px;}
.message_2 ul li dl { overflow: hidden;  margin: 0px 30px 81px 30px;}
.message_2 ul li dl.dl2 { margin-left: 65px;}
.message_2 ul li dt { float: left; display: inline;}
.message_2 ul li .dl2 dt { float: right; display: inline; }
.message_2 ul li dd { font-size: 14px; color: #fff; line-height: 40px; width: 210px; }
.message_2 ul li .dl1 dd { margin-left: 270px; margin-top: 42px;}
.message_2 ul li .dl2 dd { margin-right: 42px; margin-top: 60px;}

.box7 { /*background: url("img/bg3.png") 0 43px repeat-x;*/ padding: 0px; height: 840px;}

.steps_box { background: #f8f8f8; padding: 35px 0px 30px 0px;}
.steps_box h5 { margin-bottom: 35px; margin-left: 25px;}
.steps_info { text-align: center; margin: 0px 29px;}
.steps_box span { width: 321px; text-align: center; display: inline-block;}
.steps_box .span2 { margin: 0px 75px;}
.steps_box span a { display: inline-block; font-size: 18px; width: 321px; height: 55px; line-height: 55px; background: #53b9fa; border-radius: 12px; color: #fff; text-align: center; margin-bottom: 10px;}
.steps_box span em { font-size: 12px; color: #999; font-style: normal; display: inline-block; height: 38px; margin: 0px 25px;}

.box8 { padding: 129px 0px 142px 0px; height: 317px; background: #f7fbf3; }
.box8 h3 { margin: 0px 0px 40px 0px; color: #cacbcd; font-size: 60px;}
.step_box { position: relative; width: 877px; margin: 0 auto;}
.step_box span { position: absolute; /*background: url("img/step_bg.png") 0 0 no-repeat;*/ display: inline-block; height: 78px; line-height: 58px; color: #6dac00; font-size: 18px; text-align: center;}
.step_box span.step1 { top: 0px; left: 22px; width: 119px;}
.step_box span.step2 { top: 0px; left: 213px; width: 178px;}
.step_box span.step3 { top: 0px; left: 451px; width: 199px;}
.step_box span.step4 { top: 0px; left: 758px; width: 119px;}
.step_box img { position: absolute; left: 0px; top: 91px;}

/*语音通话*/
.ft_banner2 { width: 100%; height: 430px; /*background: url("img/banner7.png") center center;*/}
.voice_1 { width: 100%; text-align: center;}
.voice_1 .img { margin-bottom: 60px;}

.box10 { /*background: gainsboro;  */padding: 0px; /*height: 700px;*/
    display: flex;
    /* width: 100%; */
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
}
// .voice_2 { position: relative; left: 30%; margin-left: -400px;}
.voice_2 ul li { float: left; display: inline; height: 420px; color: #fff; cursor: pointer; position: relative; }
.voice_2 ul li.li1 {
    background: #4a9ebd
}

.voice_2 ul li.li2 {
    background: #4abdb9
}

.voice_2 ul li.li3 {
    background: #90d73d
}

.voice_2 ul li.li4 {
    background: #e3d02c
}

.voice_2 ul li.li5 {
    background: #e37e2c
}

.voice_2 ul li.li6 {
    background: #cc428d
}

.voice_2 ul li.li7 {
    background: #e3d02c
}

.voice_2 ul li.li8 {
    background: #90d73d
}

.voice_2 ul li.li9 {
    background: #4abdb9
}

.voice_2 ul li.li10 {
    background: #4a9ebd
}
.voice_2 .fold { width: 100%; height: 100%; /*margin-top: 150px;*/ text-align: center; position: absolute; top: 0px; left: 0px;display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;}
.voice_2 .fold .img { display: block; /*background: url("img/icon.png") 0 0 no-repeat;*/ margin-bottom: 20px; margin-top: 236px;}
.voice_2 .li1 .fold .img { background-position: -482px -181px; width: 56px; height: 113px; margin: 236px 20px 20px 20px;}
.voice_2 .li2 .fold .img { background-position: 0 -417px; width: 51px; height: 138px; margin: 236px 25px 28px 25px;}
.voice_2 .li3 .fold .img { background-position: -64px -413px; width: 54px; height: 142px; margin: 239px 23px 20px 23px;}
.voice_2 .li4 .fold .img { background-position: -136px -204px; width: 76px; height: 96px; margin: 276px 12px 26px 12px;}
.voice_2 .li5 .fold .img { background-position: -141px -420px; width: 53px; height: 116px; margin: 259px 23px 24px 23px;}
.voice_2 .li6 .fold .img { background-position: -172px -306px; width: 54px; height: 104px; margin: 270px 23px 25px 23px;}

.voice_2 .fold .txt { font-size: 24px; display: block; width: 25px; font-weight: normal; margin: 15px 38px; line-height: 25px;}
.voice_2 .unfold { width: 100%; height: 100%; display: none; position: absolute; top: 0px; left: 0px;}
.voice_2 .unfold dl { margin: 50px 60px 0px 60px;}
.voice_2 .unfold dt { width: 100%; text-align: center; margin-bottom: 40px;}
.voice_2 .unfold dd { font-size: 18px; line-height: 35px;}
.voice_2 .unfold dd b { font-size: 30px; font-weight: normal;}
.voice_2 .unfold dd b a { font-size: 14px; display: inline-block; color: #fff; margin-left: 40px;}

.box11 .item_box_wp .title { background: none;}
.voice_3 { margin: 58px 0px 50px 0px; overflow: hidden;}
.voice_3 ul li { float: left; display: inline; width: 215px; margin-right: 105px; text-align: center;}
.voice_3 ul li.li4 { margin-right: 0px;}
.voice_3 dt { /*background: url("img/icon.png") 0 0 no-repeat;*/}
.voice_3 ul li.li1 dt { background-position: -217px -430px; width: 124px; height: 109px; margin: 27px 45px 20px 45px;}
.voice_3 ul li.li2 dt { background-position: -241px -295px; width: 157px; height: 125px; margin: 10px 29px 20px 29px;}
.voice_3 ul li.li3 dt { background-position: -227px -146px; width: 94px; height: 135px; margin: 0px 60px 20px 60px;}
.voice_3 ul li.li4 dt { background-position: -178px 0px; width: 64px; height: 100px; margin: 36px 75px 20px 75px;}
.voice_3 dd { font-size: 12px; color: #666;}
.voice_3 dd b { font-size: 18px; color: #333; font-weight: normal;}
.voice_3 dd a { color: #666; display: inline-block; margin-top: 10px;}

.ft_banner3 { width: 100%; height: 430px; /*background: url("img/banner10.png") center center;*/}
h1{
	font-size: 25px;
	font-weight: bold;
	text-align: center;
}
h2{
	font-size: 20px;
	text-align: center;
}
a{
	align: center;
	font-size: 20px;
}
p{
	margin-left: 10%;
}
button {
    font-family: 微软雅黑;
    margin-left: 37%;
    background: white;
    border: 1px solid #298FF8;
    width: 110px;
    height: 35px;
    font-size: 13px;
    font-weight: bold;
    border-radius: 12px;
}
.clear{clear:both}
img{display: inline-block}
.p-magin-1{
    margin-top:1.5%
}

h1, h2, h3, h4, h5, h6 {
    color: #fff;
}
</style>
